import { loadView } from '@/helper/utils'
import { lpLayout } from '@/components/layouts/Lp'

export default {
  path: '/l/:lpDir/:lpCode/:code',
  name: 'ClientLp',
  component: lpLayout(loadView('lp/ClientLp'))
}
